import React, {useContext, useState} from 'react';
import {Box, Collapse} from '@material-ui/core';
import {Button, Typography} from '../../../common/components/libs';
import {ExpandLess, ExpandMore, Done, Close} from '@material-ui/icons';
import {TariffTypes, TariffVariant} from '../models';

const tariffPrices = {
    Simple: '742,5 Руб./Мес.',
    Basic: '2175 Руб./Мес.',
    Advanced: '2925 Руб./Мес.',
}

const simpleItems = [
    'Идеальная замена бумажному меню, моментально в телефоне гостя',
    'Категории, позиции, модификаторы без ограничений',
    'Показ категорий и позиций по времени',
    'Фотографии и описания для позиций',
    'Cтоп-лист и перевод на разные языки',
    'До 3х разных меню в комплекте',
]

const basicItems = [
    'Заказы на доставку, на вынос, внутри заведения',
    'Скидки в % и в рублях',
    'Интеграция с Iiko'
]

const advancedItems = [
    'Оплата в момент заказа картой (эквайринг 2.6%)',
    'Оплата в момент заказа СБП (эквайринг 1%)',
    'Выдача чеков без покупки онлайн-кассы'
]

interface TariffCardProps {
    tariff: TariffVariant
    openForm: (tariff: TariffVariant) => void
}

export const TariffCard: React.FC<TariffCardProps> = ({tariff, openForm}) => {
    const [expanded, setExpanded] = useState<boolean>(false)

    return (
        <Box css={{
            display: 'flex',
            flexDirection: 'column',
            border: '1px solid rgba(56, 54, 64, 0.4)',
            borderRadius: 10,
            padding: '15px 20px',
            boxShadow: expanded ? '0px 0px 10px rgba(56, 54, 64, 0.4)' : null,
            //@ts-ignore
            transition: 'all 0.35s',
            //@ts-ignore
            '&:hover': {
                boxShadow: '0px 0px 10px rgba(56, 54, 64, 0.4)',
            }
        }}>
            <Box css={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
            }}>
                <Box css={{display: 'flex', flexDirection: 'column', gridGap: 3}}>
                    <Typography variant={"h4"}>
                        {TariffTypes[tariff]}
                    </Typography>

                    <Typography variant={'subtitle2'} style={{ fontWeight: 400, marginRight: 10 }}>
                        от {tariffPrices[tariff]}
                    </Typography>

                    <Box css={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}
                         onClick={() => setExpanded(!expanded)}>
                        {expanded ? <ExpandLess/> : <ExpandMore/>}
                        <Typography variant={'caption'}>
                            {expanded ? 'Скрыть' : 'Подробнее'}
                        </Typography>
                    </Box>
                </Box>
                <Box css={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <Button variant={"contained"} color={"secondary"} onClick={() => {
                        openForm(tariff)
                    }}>
                        Подключить
                    </Button>
                </Box>
            </Box>
            <Collapse in={expanded}>
                <Box css={{display: 'flex', flexDirection: 'column', marginTop: 10, gridGap: 10 }}>
                    {simpleItems.map((item, index) => (
                        <Box key={`${tariff}_simple_${index}`} css={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gridGap: 10 }}>
                            <Done style={{ color: 'rgba(0, 192, 40, 0.8)' }}/>
                            <Typography>
                                {item}
                            </Typography>
                        </Box>
                    ))}
                    {basicItems.map((item, index) => (
                        <Box key={`${tariff}_basic_${index}`} css={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gridGap: 10 }}>
                            {tariff !== 'Simple' ? <Done style={{ color: 'rgba(0, 192, 40, 0.8)' }}/> : <Close style={{ color: 'rgba(46, 46, 46, 0.4)' }}/>}
                            <Typography>
                                {item}
                            </Typography>
                        </Box>
                    ))}
                    {advancedItems.map((item, index) => (
                        <Box key={`${tariff}_advanced_${index}`} css={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gridGap: 10 }}>
                            {tariff === 'Advanced' ? <Done style={{ color: 'rgba(0, 192, 40, 0.8)' }}/> : <Close style={{ color: 'rgba(46, 46, 46, 0.4)' }}/>}
                            <Typography>
                                {item}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </Collapse>
        </Box>
    )
}